import { Exception } from './exception';

/**
 * Thrown when mandatory query parameters exceeds the given length.
 */
export class MandatoryQueryParameterTooLongException extends Exception {}
